import React, { Component, Fragment, } from 'react';
import { connect } from 'react-redux';
import CardAddItem from "./CardAddedItem";
import hideFromRoutes from '../hoc/hideFromRoutes';


class CardAddedList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      listFolios: [{ "bin_id": 801, "type": "voucher", "number": "508150301387", "pin": null, "parent_code": "otros", "name": "Otros" },
      { "bin_id": 234, "type": "voucher", "number": "234242342423423432", "pin": null, "parent_code": "otros", "name": "Otros" }
      ]
    };
  }

  render() {
    return (
      <Fragment>
        <div className="container-list-added-items">
          {
            this.props.cardList.map((itemAdded, index) => {
              return (
                <CardAddItem
                  key={index}
                  nameFolio={itemAdded.name}
                  typeFolio={itemAdded.type}
                  numberFolio={itemAdded.number}
                  item={itemAdded}
                  handleInvalidateCard={this.props.handleInvalidateCard}
                  parentCode={itemAdded.parent_code}
                />
              )
            })
          }

          {
            (this.props.cardList.length != 0 &&
              <div className={`${this.props.isDeleteLoading ? 'layer-delete-loading' : 'layer-delete-hide'}`}>
                <div className="layer-circle-loading">
                  <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
                </div>
              </div>

              || "")
          }

        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ cards }) => {

  return {
    cardList: cards.cardList,
    isDeleteLoading: cards.isDeleteLoading
  };
};

export default hideFromRoutes(
	connect(mapStateToProps, null)(CardAddedList), [
		'/error',
		'/butacas',
     '/pago',
	  '/confirmacion',
	  '/'
]);
